module.exports = __webpack_public_path__ + "static/img/ios.aa01ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/TdownloadRisk/img/ios.png
// module id = AydC
// module chunks = 2